import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../styles/colors';
import { breakpoint } from '../../styles/constants';
import { dataAlign } from '../../styles/mixins';

type Align = 'left' | 'center' | 'right';
type Size = 'small' | 'medium' | 'big';

export interface WxTitleProps {
  align?: Align;
  size?: Size;
  overTitle?: string;
  title?: string;
  darkMode?: boolean;
  children?: React.ReactNode;
}

/** Size is only available on desktop, pass title via title prop or children */
const WxTitle = ({
  overTitle = '',
  title = '',
  align = 'center',
  darkMode = false,
  size = 'medium',
  children,
}: WxTitleProps) => {
  return (
    <Container data-align={align} data-size={size} $darkMode={darkMode}>
      {overTitle && <h2>{overTitle}</h2>}
      <h1 style={{ lineHeight: 1 }}>{children ? children : title}</h1>
    </Container>
  );
};

const Container = styled.div<{ $darkMode: boolean }>`
  --color: ${(props) => (props.$darkMode ? COLORS.white : COLORS.black)};
  width: fit-content;

  h1,
  h2 {
    color: var(--color);
    text-transform: uppercase;
    font-weight: 900;
  }

  h2 {
    color: ${COLORS.red};
    font-size: 0.75rem;
    margin-bottom: 0.3125rem;
  }

  h1 {
    max-width: 18ch;
    font-size: 1.125rem;

    @media (min-width: ${breakpoint}) {
      font-size: 1.5rem;
      max-width: 30ch;
    }
  }

  &[data-size='small'] {
    h1 {
      @media (min-width: ${breakpoint}) {
        font-size: 1.25rem;
      }
    }
  }

  &[data-size='big'] {
    h1 {
      font-size: 1.5rem;
      line-height: 1;

      @media (min-width: ${breakpoint}) {
        font-size: 3.75rem;
      }
    }
  }

  ${dataAlign}
`;

export default WxTitle;
